/**
 * メンター候補者申し込みのバリデーション
 */

import * as validate from '~/utility/validation/validation';

export default (body: any): any => new Promise((resolve, reject) => {
  const {
    last_name,
    first_name,
    last_name_kana,
    first_name_kana,
    email,
    tel,
    sex,
    birthday_year,
    birthday_month,
    birthday_day,
  } = body.candidate

  // 検査対象のフィールドのエラーを空配列で定義する
  const validationErrors: any = {
    last_name: [],
    first_name: [],
    last_name_kana: [],
    first_name_kana: [],
    email: [],
    tel: [],
    sex: [],
    birthday: [],
    birthday_year: [],
    birthday_month: [],
    birthday_day: [],
  };

  // 姓
  validate.required(last_name) && validationErrors.last_name.push(validate.required(last_name));
  validate.dependentChar(last_name) && validationErrors.last_name.push(validate.dependentChar(last_name));

  // 名
  validate.required(first_name) && validationErrors.first_name.push(validate.required(first_name));
  validate.dependentChar(first_name) && validationErrors.first_name.push(validate.dependentChar(first_name));

  // 姓（カナ）
  validate.required(last_name_kana) && validationErrors.last_name_kana.push(validate.required(last_name_kana));
  validate.dependentChar(last_name_kana) && validationErrors.last_name_kana.push(validate.dependentChar(last_name_kana));
  validate.fullKana(last_name_kana) && validationErrors.last_name_kana.push(validate.fullKana(last_name_kana));

  // 名（カナ）
  validate.required(first_name_kana) && validationErrors.first_name_kana.push(validate.required(first_name_kana));
  validate.dependentChar(first_name_kana) && validationErrors.first_name_kana.push(validate.dependentChar(first_name_kana));
  validate.fullKana(first_name_kana) && validationErrors.first_name_kana.push(validate.fullKana(first_name_kana));

  // メールアドレス
  validate.required(email) && validationErrors.email.push(validate.required(email));
  validate.email(email) && validationErrors.email.push(validate.email(email));

  // 電話番号
  validate.required(tel) && validationErrors.tel.push(validate.required(tel));
  validate.tel(tel) && validationErrors.tel.push(validate.tel(tel));
  validate.halfNum(tel) && validationErrors.tel.push(validate.halfNum(tel));

  // 性別
  validate.required(sex) && validationErrors.sex.push(validate.required(sex));

  if(Object.keys(validationErrors).every(key => validationErrors[key].length === 0)) {
    resolve(body);
  } else {
    reject(validationErrors);
  };
});
